'use client';
import styled from 'styled-components';

export const Paragraph = styled.p`
  ${props =>
    props.$typography
      ? props.theme.typography[props.$typography]
      : props.theme.typography.body};
`;
